/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Header_ProvidersInputs */

const en_platform_header_providers = /** @type {(inputs: Platform_Header_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Providers`)
};

const zh_hans1_platform_header_providers = /** @type {(inputs: Platform_Header_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务商`)
};

const pt_br2_platform_header_providers = /** @type {(inputs: Platform_Header_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedores`)
};

const es_platform_header_providers = /** @type {(inputs: Platform_Header_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedores`)
};

const fr_platform_header_providers = /** @type {(inputs: Platform_Header_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseurs`)
};

const de_platform_header_providers = /** @type {(inputs: Platform_Header_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter`)
};

const ru_platform_header_providers = /** @type {(inputs: Platform_Header_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщики`)
};

const it_platform_header_providers = /** @type {(inputs: Platform_Header_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Providers" |
*
* @param {Platform_Header_ProvidersInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_header_providers = /** @type {((inputs?: Platform_Header_ProvidersInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Header_ProvidersInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_header_providers(inputs)
	if (locale === "pt-BR") return pt_br2_platform_header_providers(inputs)
	if (locale === "es") return es_platform_header_providers(inputs)
	if (locale === "fr") return fr_platform_header_providers(inputs)
	if (locale === "de") return de_platform_header_providers(inputs)
	if (locale === "ru") return ru_platform_header_providers(inputs)
	if (locale === "it") return it_platform_header_providers(inputs)
	return en_platform_header_providers(inputs)
});